<template>
  <div id="sc-other-cost">
    <p class="text-size-20">STOCKCREW倉庫の商品に対する費用をご確認いただけます。</p>
    <div class="panel-body">
      <expense-detail-table
        :url="'/Warehouse/sc/expense/other-cost'"
        :method="'get'"
        :columns="$options.columns"
        :searchValue="filters"
        :paginationStorageKey="'scOtherCost'"
        @updateFilters="updateFilters"
        @onHandleSearch="onHandleSearch"
        @confirmDownloadCsv="openModalConfirmDownloadCsv"
        ref="scOtherCostTable"
      >
        <template slot="detailDate" slot-scope="props">
          <span>{{ formatDate(props.rowData.detailDate) }}</span>
        </template>
        <template slot="detail" slot-scope="props">
          <div v-html="props.rowData.detail" class="mr-r-5"></div>
        </template>
        <template slot="serviceName" slot-scope="props">
          <span>{{ props.rowData.serviceName }}</span>
        </template>
        <template slot="quantity" slot-scope="props">
          <span>{{ props.rowData.quantity }}</span>
        </template>
        <template slot="unitCost" slot-scope="props">
          <span>{{ formatAmount(props.rowData.unitCost) }}</span>
        </template>
        <template slot="cost" slot-scope="props">
          <span>{{ formatAmount(props.rowData.cost) }}</span>
        </template>
      </expense-detail-table>

      <modal-confirm-download-csv
        v-if="showModalConfirmDownloadCsv"
        :message="`費用明細（保管料等）CSVをダウンロードします。<br> よろしければ「ダウンロード」ボタンを押してください。`"
        @close="closeModalConfirmDownloadCsv"
        @downloadCsv="handleDownloadCsv"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ExpenseDetailTable from './components/ExpenseDetailTable'
import Util from '@/common/utility'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import ModalConfirmDownloadCsv from '@/view/deliveryRequests/components/ModalConfirmDownloadCsv.vue'
import WarehouseScService from '@/services/warehousescservice'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  components: {
    ExpenseDetailTable,
    ModalConfirmDownloadCsv
  },
  data () {
    return {
      showModalConfirmDownloadCsv: false,
      filters: {
        detail: null,
        from: null,
        to: null
      }
    }
  },
  columns: [
    {
      title: '日付',
      name: 'detailDate',
      cellClass: 'text-center',
      headerClass: 'text-center w-180'
    },
    {
      title: '明細',
      name: 'detail',
      cellClass: '',
      headerClass: 'text-center header-detail'
    },
    {
      title: 'サービス名',
      name: 'serviceName',
      cellClass: '',
      headerClass: 'text-center w-150'
    },
    {
      title: '数量',
      name: 'quantity',
      cellClass: 'text-right',
      headerClass: 'text-center w-100'
    },
    {
      title: '単価(税抜)',
      name: 'unitCost',
      cellClass: 'text-right',
      headerClass: 'text-center w-100'
    },
    {
      title: '金額(税抜)',
      name: 'cost',
      cellClass: 'text-right',
      headerClass: 'text-center w-120'
    }
  ],
  mounted () {
    let logParams = {
      name: eventCode.warehouse_sc.expense_details_tab.other_cost.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)

    let self = this
    this.$events.listen('apiSuccess', (url) => {
      if (url === '/Warehouse/sc/expense/other-cost') {
        self.loader && self.loader.hide()
      }
    })
  },
  methods: {
    formatAmount (value) {
      return `¥${Util.formatMoney(value, 1, '.', '')}`
    },
    formatDate (value) {
      return value ? moment(value).format('YYYY/MM/DD') : null
    },
    updateFilters (filters) {
      this.filters = filters
    },
    onHandleSearch () {
      let logParams = {
        name: eventCode.warehouse_sc.expense_details_tab.other_cost.click_search_btn,
        properties: this.filters
      }
      EventService.postTrackLog(logParams)
    },
    async handleDownloadCsv () {
      let logParams = {
        name: eventCode.warehouse_sc.expense_details_tab.other_cost.click_download_btn,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      let sellerId = this.$store.getters.getUser.sellerId
      let reportTime = moment(new Date()).format('YYYYMMDDHHmmss')
      let filename = `stockcrewWarehouse_otherCost_${sellerId}_${reportTime}.csv`
      let params = {
        sellerId: sellerId,
        detail: this.filters.detail,
        from: this.filters.from,
        to: this.filters.to
      }

      this.closeModalConfirmDownloadCsv()
      await WarehouseScService.exportOtherCost(params, filename)
        .then(response => {
        })
        .catch(error => {
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
    },
    openModalConfirmDownloadCsv () {
      this.showModalConfirmDownloadCsv = true
    },
    closeModalConfirmDownloadCsv () {
      $('#confirm-download-cvs-modal').modal('hide')
      this.showModalConfirmDownloadCsv = false
    }
  }
}
</script>

<style scoped>
 #sc-other-cost /deep/ .panel-body {
    background-color: #fff;
    border: 1px solid #ccc;
  }
@media (max-width: 1200px) {
  #sc-other-cost /deep/ .table-wrapper {
    width: 100%;
    overflow-y: hidden;
    overflow-x: auto;
  }
  #sc-other-cost /deep/ .table {
    width: max-content;
    max-width: max-content;
  }
  #sc-other-cost /deep/ .header-detail {
    width: 500px;
  }
  #sc-other-cost /deep/ .box-base-table-search {
    display: block;
    justify-content: unset;
    align-items: unset;
    flex-wrap: unset;
  }
  #sc-other-cost /deep/ .box-base-table-search .sale-detail-search {
    display: block;
  }
  #sc-other-cost /deep/ .box-base-table-search .search-block {
    display: block;
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseSc/OtherCost.vue